import { forwardRef } from 'react'
import { IconButtonProps } from './IconButton.types'
import { IconButtonStyled } from './IconButton.styles'
import Icon from '../Icon'
import Text from '../Text'
import IconButtonBadge from './IconButtonBadge'

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className = '', styles, icon, iconset, badge, text, ...props }, ref) => (
    <IconButtonStyled
      className={`IconButton ${className}`}
      sx={styles}
      ref={ref}
      {...props}>
      {text && <Text {...text} />}
      <IconButtonBadge {...badge}>
        <Icon name={icon} iconset={iconset} />
      </IconButtonBadge>
    </IconButtonStyled>
  )
)

IconButton.displayName = 'IconButton'
export default IconButton
